// Constants Library
import { ROOT_CONSTANT } from "../../../constants";

const { icon_excel, icon_add, icon_add_white, icon_check_circle_outlined } =
  ROOT_CONSTANT.IMG.ICON;

export const BTN_IMG = {
  EXPORT: icon_excel,
  ADD: icon_add,
  CHECK_WHITE: icon_check_circle_outlined,
  ADD_WHITE: icon_add_white,
};
